export default "assets/images/stars-5-3423f8b2.png";